import api from "@/lib/api";

export async function downloadFile(path, filename, params) {
  const r = await api.get(path, { params, responseType: "blob" });
  const u = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = u; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 5000);
}

export function nzDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-NZ", { timeZone: "Pacific/Auckland", day: "2-digit", month: "2-digit",
    year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
}

export function nzTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-NZ", { timeZone: "Pacific/Auckland", hour: "2-digit", minute: "2-digit", hour12: false });
}

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
}

export const HAZARD_FIELDS = [["ref_id", "ID"], ["build_phase", "Build phase"], ["activity", "Activity"], ["hazard", "Hazard"],
  ["potential_harm", "Potential harm"], ["who_at_risk", "Who is at risk"], ["initial_risk", "Initial risk"],
  ["controls", "Controls"], ["residual_risk", "Residual risk"], ["responsible", "Responsible"],
  ["swms_required", "SWMS required"], ["critical_risk", "Critical risk"], ["reference", "Reference"]];

export const isYes = (v) => /^(y|yes|true|1|x|required)/i.test(String(v || "").trim());

export function filterHazards(rows, f) {
  const q = (f.q || "").trim().toLowerCase();
  return rows.filter(h => (!f.phase || h.build_phase === f.phase)
    && (!f.risk || h.initial_risk === f.risk || h.residual_risk === f.risk)
    && (f.flag !== "swms" || isYes(h.swms_required))
    && (f.flag !== "critical" || isYes(h.critical_risk))
    && (!q || HAZARD_FIELDS.some(([k]) => String(h[k] || "").toLowerCase().includes(q))));
}

export const distinct = (rows, ...keys) =>
  [...new Set(rows.flatMap(r => keys.map(k => r[k])).filter(Boolean))].sort();
